import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { useAuth } from '../Contexts/AuthContext';
import Login from '../Pages/Authentication/Login';
import Signup from '../Pages/Authentication/Signup';
import ForgotPassword from '../Pages/Authentication/ForgotPassword';
import UpdatePassword from '../Pages/Authentication/UpdatePassword';
import ConnectedTellUsAboutYourBusiness from '../Pages/AboutYourBusiness/ConnectedTellUsAboutYourBusiness';
import Portal from '../Pages/Portal/Portal';
import { CampaignsProvider } from '../Contexts/CampaignsContext';
import AccountManagment from '../Pages/Authentication/AccountManagement';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';

const Routes = () => {
    const { currentUser } = useAuth();

    const { isAuthenticated, emailIsVerified, accountIsComplete } = { ...currentUser };
    let routes;

    if (isAuthenticated === null) {
        return null;
    } else if (isAuthenticated && emailIsVerified && accountIsComplete) {
        routes = (
            <Switch>
                <Route path="/portal">
                    <CampaignsProvider>
                        <Portal />
                    </CampaignsProvider>
                </Route>
                <Route exact path="/updatePassword">
                    <UpdatePassword />
                </Route>
                <Redirect to="/portal" />
            </Switch>
        );
    } else if (isAuthenticated && !emailIsVerified) {
        routes = (
            <Switch>
                <Route path="/accountManagement/sendVerificationEmail">
                    <AccountManagment />
                </Route>
                <Route path="/accountManagement/verifyEmail">
                    <AccountManagment />
                </Route>
                <Redirect to="/accountManagement/sendVerificationEmail" />
            </Switch>
        );
    } else if (isAuthenticated && emailIsVerified && !accountIsComplete) {
        routes = (
            <Switch>
                <Route exact path="/aboutYourBusiness/form">
                    <ConnectedTellUsAboutYourBusiness />
                </Route>

                <Route exact path="/aboutYourBusiness/plan">
                    <ConnectedTellUsAboutYourBusiness />
                </Route>
                <Route exact path="/aboutYourBusiness/view">
                    <ConnectedTellUsAboutYourBusiness />
                </Route>
                <Route exact path="/aboutYourBusiness/summary">
                    <ConnectedTellUsAboutYourBusiness />
                </Route>
                <Redirect to="/aboutYourBusiness/form" />
            </Switch>
        );
    } else {
        routes = (
            <div style={{ marginLeft: '10px', marginRight: '10px' }}>
                <Switch>
                    <Route exact path="/aboutYourBusiness/plan">
                        <ConnectedTellUsAboutYourBusiness />
                    </Route>
                    <Route exact path="/accountManagement/resetPassword">
                        <AccountManagment />
                    </Route>

                    <Route exact path="/login">
                        <Login />
                    </Route>
                    <Route exact path="/signup">
                        <Signup />
                    </Route>
                    <Route exact path="/forgotPassword">
                        <ForgotPassword />
                    </Route>
                    <Redirect to="/login" />
                </Switch>
            </div>
        );
    }
    return (
        <Router>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    minHeight: '100vh',
                }}
            >
                <Navbar />

                {routes}
                <Footer />
            </div>
        </Router>
    );
};

export default Routes;
